import { render, staticRenderFns } from "./ReportShortCourses.vue?vue&type=template&id=c9b03522"
import script from "./ReportShortCourses.vue?vue&type=script&lang=js"
export * from "./ReportShortCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports